export const FETCH_TEMPLATE = 'CUSTOMIZE/FETCH/FETCH_REQUEST';
export const FETCH_TEMPLATE_SUCCESS = 'CUSTOMIZE/FETCH/FETCH_SUCCESS';
export const FETCH_TEMPLATE_FAILURE = 'CUSTOMIZE/FETCH/FETCH_FAILURE';

export const SET_SELECTED_TEMPLATE = 'CUSTOMIZE/SELECTED/SET';

export const OPEN_SAVE_MODAL = 'CUSTOMIZE/MODAL/SAVE/OPEN';
export const CLOSE_SAVE_MODAL = 'CUSTOMIZE/MODAL/SAVE/CLOSE';

export const SEND_CUSTOMIZE = 'CUSTOMIZE/GENERAL/SEND_REQUEST';
export const SEND_CUSTOMIZE_SUCCESS = 'CUSTOMIZE/GENERAL/SEND_SUCCESS';
export const SEND_CUSTOMIZE_FAILURE = 'CUSTOMIZE/GENERAL/SEND_FAILURE';

export const TOGGLE_EDIT = 'CUSTOMIZE/EDIT/TOGGLE';
